import React, { useContext, useEffect } from "react";
import styled from "styled-components";

import Back from "./ui/Back";
import Button from "./ui/Button";
import ButtonGroup from "./ui/ButtonGroup";
import Errors from "./ui/Errors";
import { isEnquiry } from "../helper";
import { tableStore } from "../store/table";
import Text from "./ui/Text";

const Wrapper = styled.div`
  max-width: 408px;
  margin: 0 auto;
`;

const Title = styled.h3`
  color: white;
  font-size: 14px;
  margin: 0;
  text-transform: uppercase;
`;

const Details = () => {
  const { table, actions } = useContext(tableStore);

  useEffect(() => {
    if (
      window.ga &&
      window.gaKey &&
      table.bookingTypeTitle &&
      typeof table.numPeople === "number"
    ) {
      window.gaKey.forEach((key) => {
        window.ga(
          `${key}.send`,
          "event",
          "DMN Callback",
          isEnquiry(table.check) ? "Enquiry" : "Booking",
          table.bookingTypeTitle,
          table.numPeople
        );
      });
    }

    if (typeof window.fbq !== "undefined") {
      window.fbq('track', 'Purchase', { currency: "GBP", value: 0.00 });
    }

    const eventLabelPostfix = window.location.search.includes("DMN-") ? " - Deposit" : ""
    actions.sendAnalyticsData({
      hitType: "event",
      eventAction: "Complete",
      eventLabel: "Booking/Enquiry",
    });
    actions.sendAnalyticsData({
      hitType: "event",
      eventAction: "Complete",
      eventLabel: (isEnquiry(table.check) ? "Enquiry" : "Booking") + eventLabelPostfix,
    });
  }, []);

  return (
    <>
      <Back onClick={() => actions.reset()}>Back</Back>

      <Wrapper>
        <Title>{isEnquiry(table.check) ? "Enquiry Received" : "Booking Confirmed"}</Title>
        <Text>
          {isEnquiry(table.check) ? "We will be in touch to confirm your booking." : "Thank you for your booking, we look forward to welcoming you."}
        </Text>
        <Errors errors={table.errors} />
        <ButtonGroup>
          <Button
            onClick={() => actions.reset()}
            active
            disabled={table.loading}
          >
            Reset
          </Button>
        </ButtonGroup>
      </Wrapper>
    </>
  );
};

export default Details;
